import script from "./CustomFooter111111.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFooter111111.vue?vue&type=script&setup=true&lang=js"

import "./CustomFooter111111.vue?vue&type=style&index=0&id=525eaeda&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525eaeda"]])

export default __exports__